var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinishLaterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8177 17.9567C15.201 17.9567 17.9438 15.2482 17.9438 11.9071C17.9438 8.56598 15.201 5.85749 11.8177 5.85749C8.43427 5.85749 5.69149 8.56598 5.69149 11.9071C5.69149 15.2482 8.43427 17.9567 11.8177 17.9567ZM11.8177 18.9997C15.7844 18.9997 19.0001 15.8242 19.0001 11.9071C19.0001 7.98993 15.7844 4.81445 11.8177 4.81445C7.85092 4.81445 4.63525 7.98993 4.63525 11.9071C4.63525 15.8242 7.85092 18.9997 11.8177 18.9997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05537 1.90577H15.4084V6.75921C15.7931 7.02102 16.147 7.32376 16.4638 7.66107V0.863281H0V14.8326H6.21828C6.04114 14.5016 5.89319 14.153 5.77781 13.7901H1.05537V1.90577Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3913 12.7388L11.3913 6.69336L12.4626 6.69336L12.4626 12.7388L11.3913 12.7388Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.864 11.8283L15.4105 13.5794L14.9385 14.5117L11.3919 12.7606L11.864 11.8283Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2957 3.02273L2.2957 4.71885e-08L3.38892 0L3.38892 3.02273L2.2957 3.02273Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76177 3.02273L7.76177 4.71885e-08L8.85498 0L8.85498 3.02273L7.76177 3.02273Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2278 3.02273L13.2278 4.71885e-08L14.321 0L14.321 3.02273L13.2278 3.02273Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishLaterIcon);
export default __webpack_public_path__ + "static/media/finish-later-icon.cdaf08199318d697bf1cc4ed846de2ad.svg";
export { ForwardRef as ReactComponent };